import React, { useContext, } from 'react'
import Section from '../../../UIcomponent/Section'
import Col from '../../../UIcomponent/Column'
import './TeacherReviews.scss'
import LocalContext from '../../../Context/LocalContetxt'
import { ThemeContext } from 'styled-components'
import { Rate } from '../../../UIcomponent/Rate'
import Masonry from 'react-masonry-css'
import { MasonryBreakPoints } from "../../../Utility/MasonryBreakPoints"
import AvatarDefault from '../../../Assets/images/AvatarDefault.jpg'
import StarRoundedIcon from '@material-ui/icons/StarRounded';
import InfiniteScroll from 'react-infinite-scroller'
import { Loader } from '../../../UIcomponent/Loader'
import Urls from '../../../Utility/Urls'
import moment from 'moment-jalaali'
import { PersianMonth } from '../../../Utility/Method/DateTimeConstant'
const TeacherReviews = (props) => {
    const { data, intro, LoadMore, stats } = props
    const lang = useContext(LocalContext).lang
    const theme = useContext(ThemeContext)
    let loading = data && intro ? false : true
    let statsLoading = stats && intro ? false : true
    // moment.loadPersian({ dialect: 'persian-modern' })
    return (
        <Section
            flexDir='column'
            className='l__TeacherReviews'
        >
            <Col
                xl={22} lg={21} md={22} sm={22} xs={22}
                className='c__TeacherReviews'
            >
                <Col
                    // xl={24} lg={24} md={24} sm={24} xs={24}
                    className='o__TeacherReviews__Title'
                    loading={loading}
                // skeletonType='line'
                >
                    {loading === false && `نظرات زبان آموزان`}
                </Col>
                <Col
                    xl={24} lg={24} md={24} sm={24} xs={24}
                    className='o__TeacherReviews__OverAllRate'
                    loading={loading}
                    skeletonType='line'
                >
                    {
                        loading === false && (data.Reviews !== null ?
                            <>
                                <Col
                                    className='o__TeacherReviews__OverAllRate__Value'
                                >
                                    {intro.Rate.toString().length > 3 ? intro.Rate.toFixed(1) : intro.Rate}
                                </Col>
                                <Rate
                                    value={intro.Rate}
                                    allowHalf={true}
                                    allowClear={false}
                                    disabled={true}
                                    icon={<StarRoundedIcon fontSize="inherit" />}
                                    style={{
                                        direction: lang === 'fa' || lang === 'ar' ? 'ltr' : 'rtl',
                                        color: theme.warning,
                                        opacity: 1
                                    }}
                                    size='larg'
                                />
                            </>
                            :
                            <Col
                                className='o__TeacherReviews__Norecord'
                            >
                                هنوز نظری ثبت نشده است.
                            </Col>
                        )
                    }
                </Col>
                <Col
                    xl={24} lg={24} md={24} sm={24} xs={24}
                    className='o__TeacherReviews__ReviewerCount'
                    loading={statsLoading}
                >
                    {stats && stats.RateCount > 0 && statsLoading === false && stats.RateCount + ' رای از ' + stats.RateUserCount + ' زبان آموز '}
                </Col>
                <InfiniteScroll
                    className="infiniteScroll"
                    threshold={30}
                    pageStart={0}
                    initialLoad={false}
                    loadMore={LoadMore}
                    hasMore={data && data.Paging && loading === false ? data.Paging.HasNext : false}
                    useWindow={true}
                    loader={
                        <Loader
                            height={150}
                        />
                    }
                >
                    <Masonry
                        className="TeacherReviews-masonry-grid"
                        columnClassName="TeacherReviews-masonry-grid_column"
                        breakpointCols={MasonryBreakPoints}
                    >
                        {
                            loading === false && data.Reviews !== null && data.Reviews.map(each => {
                                let ReviewMonth = PersianMonth[Number(moment(each.ReviewDate).format('jM')) - 1]
                                return (
                                    < Col
                                        xl={21} lg={24} md={24} sm={24} xs={21}
                                        className="o__TeacherReviews"
                                    >
                                        <Col
                                            xl={24} lg={24} md={24} sm={24} xs={24}
                                            className="o__TeacherReviews__Info"
                                        >
                                            {/* <Col
                                                xl={4} lg={4} md={4} sm={6} xs={6}
                                                className="o__TeacherReviews__Info__Avatar"
                                            >
                                                <Col
                                                    style={{
                                                        backgroundImage: each.UserAvatar !== '' ? `Url(${Urls.avatar() + each.UserAvatar})` : AvatarDefault
                                                    }}
                                                ></Col>
                                            </Col> */}

                                            <Col
                                                xl={24} lg={24} md={24} sm={24} xs={24}
                                                // xl={18} lg={18} md={18} sm={18} xs={18}
                                                className="o__TeacherReviews__Info__Detail"
                                            >
                                                <Col
                                                    xl={24} lg={24} md={24} sm={24} xs={24}
                                                    className='c__TeacherReviews__Info__Detail__Name'
                                                >
                                                    <Col
                                                        xl={22} lg={18} md={18} sm={18} xs={18}
                                                        className='o__TeacherReviews__Info__Detail__Name'
                                                    >
                                                        {each.FirstName}
                                                    </Col>
                                                    <Col
                                                        className='o__TeacherReviews__Info__Detail__Name__Session'
                                                    >

                                                    </Col>
                                                </Col>
                                                <Col
                                                    xl={22} lg={18} md={18} sm={18} xs={18}
                                                    // xl={24} lg={24} md={24} sm={24} xs={24}
                                                    className='o__TeacherReviews__Info__Detail__Date'
                                                >
                                                    {moment(each.ReviewDate).format(` jDD ${ReviewMonth} jYYYY `)
                                                    }
                                                </Col>
                                            </Col>

                                        </Col>
                                        <Col
                                            xl={24} lg={24} md={24} sm={24} xs={24}
                                            className="o__TeacherReviews__Desc"
                                        >
                                            <Col
                                                xl={22} lg={18} md={18} sm={18} xs={18}
                                                className="o__TeacherReviews__Desc__Txt"
                                            >
                                                {each.Comment}
                                            </Col>

                                        </Col>
                                    </Col>
                                )
                            })
                        }
                    </Masonry>
                </InfiniteScroll>
            </Col >
        </Section >
    )
}

export default TeacherReviews
